import React from 'react';
import { Upload, message, Card, Row, Col } from 'antd';
import AgentsFilter from './AgentsFilter';
import AddAgentWagePaid from './AddAgentWagePaid';
import PaidTable from './PaidTable'
import config from '../../config';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function AgentPaid() {

    const { auth } = usePersistedStore();
    const general = useGeneralStore();
    const userToken = auth.userToken;

    const props = {
        headers: {
            Authorization: `Bearer ${userToken}`
        },
        action: `${config.apiUrls()}/v1/business/excel-import-agent-wage-paid`,
        beforeUpload: file => {
            if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                message.error(`${file.name} فایل معتبر اکسل نمی باشد`);
            }
            return file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? true : Upload.LIST_IGNORE;
        },
        onChange(info) {
            if (info.file.status === 'done') {
                message.success(`${info.file.name} با موفقیت بارگذاری شد`);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.response.Message}`);
            }
        },
    }

    return (
        <Card>
            <div>
                <button type="button" className="btn btn-primary waves-effect" onClick={() => general.ToggleAddAgentWagePaidModal()} style={{ marginLeft: 10 }}>
                    <i className="fas fa-file-invoice-dollar  font-size-16 align-middle mr-2"></i> افزودن دستی واریز
                </button>
                <Upload {...props}>
                    <button type="button" className="btn btn-warning waves-effect">
                        <i className="fas fa-file-upload  font-size-16 align-middle mr-2"></i> بارگذاری فایل پرداخت
                    </button>
                </Upload>
                <button type="button" className="btn btn-success waves-effect" style={{ float: "left" }}>
                    <a href="https://coreapi.bimeh.com\resources\Docs\AgentWagePaids.xlsx" style={{ color: "#fff" }}>
                        <i className="fas fa-file-download  font-size-16 align-middle mr-2"></i> دانلود فایل پرداخت نمونه</a>
                </button>
            </div>
            <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
                <Col span={24}>
                    <AgentsFilter />
                </Col>
                <Col span={24}>
                    <PaidTable />
                </Col>
            </Row>
            <AddAgentWagePaid />
        </Card>
    )
}
